import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HeroSection from "./components/sections/HeroSection";
import AboutSection from "./components/sections/AboutSection";
import ServicesSection from "./components/sections/ServicesSection";
import SimulatorCTA from "./components/sections/SimulatorCTA";
import PortfolioSection from "./components/sections/PortfolioSection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import BlogSection from "./components/sections/BlogSection";
import ContactSection from "./components/sections/ContactSection";
import BeforeAfterGallery from "./components/sections/BeforeAfterGallery";
import BackgroundSlideshow from "./components/effects/BackgroundSlideshow";
import SimulatorPage from "./components/simulator/SimulatorPage";
import AuthCallback from "./components/auth/AuthCallback";
import CelebrantePage from "./components/pages/CelebrantePage";
import AdminDashboard from "./components/admin/AdminDashboard";
import WhatsAppButton from "./components/ui/WhatsAppButton";
import ExitIntentModal from "./components/modals/ExitIntentModal";
import ScrollToTop from "./components/utils/ScrollToTop";

// Tools imports
import ToolsDashboard from "./components/tools/ToolsDashboard";
import RadarTool from "./components/tools/RadarTool";
import EnergyTool from "./components/tools/EnergyTool";
import LibraryTool from "./components/tools/LibraryTool";
import NextDayTool from "./components/tools/NextDayTool";
import TraditionsTool from "./components/tools/TraditionsTool";
import ConcessionsTool from "./components/tools/ConcessionsTool";
import TimelineTool from "./components/tools/TimelineTool";

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <BeforeAfterGallery />
        <SimulatorCTA />
        <PortfolioSection />
        <TestimonialsSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ExitIntentModal />
    </>
  );
};

// Simulator Page Wrapper
const SimulatorWrapper = () => {
  return (
    <>
      <Header />
      <main className="pt-20">
        <SimulatorPage />
      </main>
      <Footer />
    </>
  );
};

// Tools Page Wrapper
const ToolsWrapper = ({ children }) => {
  return (
    <>
      <Header />
      <main className="pt-20">
        {children}
      </main>
      <Footer />
    </>
  );
};

// Router component that handles auth callback detection
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/simulador" element={<SimulatorWrapper />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/celebrante" element={<ToolsWrapper><CelebrantePage /></ToolsWrapper>} />
      <Route path="/admin" element={<AdminDashboard />} />
      
      {/* Tools Routes */}
      <Route path="/ferramentas" element={<ToolsWrapper><ToolsDashboard /></ToolsWrapper>} />
      <Route path="/ferramentas/radar" element={<ToolsWrapper><RadarTool /></ToolsWrapper>} />
      <Route path="/ferramentas/energia" element={<ToolsWrapper><EnergyTool /></ToolsWrapper>} />
      <Route path="/ferramentas/biblioteca" element={<ToolsWrapper><LibraryTool /></ToolsWrapper>} />
      <Route path="/ferramentas/clausula" element={<ToolsWrapper><NextDayTool /></ToolsWrapper>} />
      <Route path="/ferramentas/tradicoes" element={<ToolsWrapper><TraditionsTool /></ToolsWrapper>} />
      <Route path="/ferramentas/concessoes" element={<ToolsWrapper><ConcessionsTool /></ToolsWrapper>} />
      <Route path="/ferramentas/timeline" element={<ToolsWrapper><TimelineTool /></ToolsWrapper>} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BackgroundSlideshow />
      <BrowserRouter>
        <ScrollToTop />
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
